import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import {Field, FieldsManager} from '../../../data/services/fields'
import {createResource, resetResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import InfoTab from './infoTab'
import ReviewsTab from '../../../common/components/module-companies/reviewsTab'
import RedirectDialog from "../../../common/components/modal/redirect-dialog";
import GoBackButton from "../../../common/components/layout/layout-components/go-back-button";
import DocumentsCreateTab from "../../../common/components/tabs/documents-tab/create-documents";
import Page from "../../../common/components/layout/layout-components/page";
import PageFooter from "../../../common/components/layout/layout-components/page/page-footer";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import {
    CREATE_PERM,
    DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    FIELD_MASK_PHONE,
    SCAC_CODE_FIELD_LENGTH
} from '../../../util/util-constants'
import {checkPerm,  getDefaultContactGroup, getDefaultUserOfficeValues, getDocumentTypesFor,
    getPreFillFromQuery,
    updateContractFields,
    updateStateFields} from '../../../common/util/util-helpers'
import {scrollErrorIntoViewFields, setSelectionRange} from '../../../common/util/util-vanilla'
import FieldOptions from "../../../components/fields/field-options";
import {InformationCircleIcon} from "@heroicons/react/24/outline";
import GroupsViewDialog from "../../../common/components/modal/groups-view-dialog";
import Layout from "../../../common/components/layout";
import NavResponsive from "../../../common/components/nav-responsive";
import {LoaderLarge} from "../../../common/components/loader";
import Card from "../../../common/components/card";

class CustomerCreateNew extends Component {

    constructor(props) {
        super(props)

        const tabs = [
            {
                name: 'CustomersInfo',
                resource: Resources.CustomersInfo,
                current: true,
                visible: true
            },
            {
                name: 'CustomersReviews',
                resource: Resources.CustomersReviews,
                current: false,
                visible: true
            },
            {
                name: 'CustomersDocuments',
                resource: Resources.CustomersDocuments,
                current: false,
                visible: checkPerm(Resources.CustomersDocuments, CREATE_PERM),
            }
        ]

        this.state = {
            // Tabs
            tabs: tabs,
            selectedTab: Resources.CustomersInfo,

            // Fields
            fields_info: this.getFieldsInfo(),
            fields_reviews: [],
            fields_contacts: [],
            contacts: [],
            fields_documents: [],

            // Modals
            redirectModalOpen: false,

            isGroupInfoDialogOpen: false,
            groupInfoData: {},

            canSwapTabs: true,
            emailExist: false,
            canSubmit: false,
        }
    }

    /** Lifecycle
     ================================================================= */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.resource !== prevProps.resource && !prevProps.resource.showRedirectDialog && !!this.props.resource.showRedirectDialog) {
            this.handleToggleRedirectDialog()
        }
        if (!!this.props.resource.errorMessage && !prevProps.resource.errorMessage && (this.props.resource.errorMessage === 'EMAIL_PARAMETER_ALREADY_EXISTS') && !this.props.ui.updateOfficeDialog) {
            this.setState({emailExist: true, selectedTab: Resources.CustomersInfo})
        }
    }

    /** Data events
     ================================================================= */
    onSubmit = () => {
        this.setState({
            fields_info: FieldsManager.validateFields(this.state.fields_info),
        }, () => {
            if (FieldsManager.checkFieldsForErrors(this.state.fields_info)) {
                let params = Object.assign({},
                    FieldsManager.getFieldKeyValues(this.state.fields_info),
                    {Reviews: this.state.fields_reviews.map((fields) => FieldsManager.getFieldKeyValues(fields))},
                    {
                        Contacts: this.state.fields_contacts.map((item) => {
                            return {
                                ContactID: item.ContactID,
                                DepartmentID: item.DepartmentID,
                                Notes: item.Notes
                            }
                        })
                    }
                )
                this.props.dispatch(createResource({
                    user: LocalStorage.get('user'),
                    params: params,
                    resource: Resources.Customers,
                    errorMessage: true,
                    showRedirectDialog: true,
                    document: this.state.fields_documents,
                    documentResource: Resources.CustomersDocuments,
                }))
            } else {
                this.handleTabChange(Resources.CustomersInfo)
                scrollErrorIntoViewFields([this.state.fields_info])
            }
        })
    }

    /** UI events
     ================================================================= */
    handleToggleRedirectDialog = () => {
        this.setState({
            createdResourceID: this.props.resource.create && this.props.resource.create.CustomerID,
            createdOrganizationID: this.props.resource.create && this.props.resource.create.OrganizationID,
            redirectModalOpen: !this.state.redirectModalOpen,
            fields_info: this.getFieldsInfo(),
            fields_reviews: [],
            fields_contacts: [],
            contacts: [],
            fields_documents: []
        })
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }
        this.tabChange(resource)
    }

    tabChange = (resource) => {
        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }

    handleFormCancel = () => {
        this.setState({
            fields_info: this.getFieldsInfo(),
            fields_reviews: [],
            fields_contacts: [],
            contacts: [],
            fields_documents: [],
        })
    }

    handleGroupInfoClick = (groupData) => {
        this.setState({
            isGroupInfoDialogOpen: true,
            groupInfoData: groupData
        })
    }

    /** Fields/Tables onChange events
     ================================================================= */
    handleUploadDocument = (files) => {
        let fields = this.state.fields_documents
        fields = fields.concat(files)
        this.setState({fields_documents: fields})
    }

    handleDeleteDocument = (item) => {
        let fields = this.state.fields_documents.filter(it => it.preview !== item.preview)
        this.setState({fields_documents: fields})
    }

    handleInputChange = (name, value) => {
        let fields = FieldsManager.updateField(this.state.fields_info, name, value)

        fields = updateContractFields(fields, name, value)
        fields = updateStateFields(fields, name, value)

        this.setState({canSubmit: true, fields_info: fields})
    }

    handleSetLocations = (fields) => {
        let updatedFields = this.state.fields_info

        for (const [key, value] of Object.entries(fields)) {
            if (key in this.state.fields_info) {
                updatedFields = FieldsManager.updateField(updatedFields, key, value)
            }
        }

        this.setState({
            fields_info: updatedFields,
            canSubmit: true
        })
    }

    handleItemInputChange = (i, name, value) => {
        let fields = this.state.phones_info[i]
        const newItems = this.state.phones_info
        newItems[i] = FieldsManager.updateField(fields, name, value)
        this.setState({canSubmit: true, phones_info: newItems})
    }

    handleAddNewReview = (fields) => {
        let arr = this.state.fields_reviews
        arr.push(fields)
        this.setState({fields_reviews: arr})
    }

    handleRemoveReview = (i) => {
        let arr = this.state.fields_reviews
        arr.splice(i, 1)
        this.setState({fields_reviews: arr})
    }

    /** Fields/Data definitions
     ================================================================= */
    getFieldsInfo = () => {
        const LegalName = getPreFillFromQuery()

        return {
            // Card 1
            CountryID: new Field('CountryID', 1, [], false, 'select', {addContainerClass: "col-span-full"}),
            GooglePlaces: new Field('GooglePlaces', '', [], false, 'google-locations', {
                setLocations: this.handleSetLocations,
                addContainerClass: "col-span-full"
            }),
            LegalName: new Field('LegalName', LegalName ?? '', ['empty'], false, "text", {addContainerClass: "col-span-6"}),
            DBAName: new Field('DBAName', '', [''], false, "text", {addContainerClass: "col-span-6"}),
            AddressName: new Field('AddressName', '', [], false, "text", {addContainerClass: "col-span-full"}),
            AddressName2: new Field('AddressName2', '', [], false, "text", {addContainerClass: "col-span-full"}),
            CityName: new Field('CityName', '', [], false, "text", {addContainerClass: "col-span-4"}),
            StateID: new Field('StateID', '', [], false, 'select', {addContainerClass: "col-span-4"}),
            PostalCode: new Field('PostalCode', '', [], false, "text", {addContainerClass: "col-span-4"}),

            ContactGroupID: new Field('ContactGroupID',
                getDefaultContactGroup() ? getDefaultContactGroup() : null,
                ['empty'], false, 'select-search',
                {addContainerClass: "col-span-full xl:col-span-6",
                    label: "CompaniesGroupID",
                    fieldOptions: (it) => {
                        return (
                            <FieldOptions
                                options={[
                                    {
                                        icon: InformationCircleIcon,
                                        onClick: () => this.handleGroupInfoClick(it?.value?.metadata),
                                        isVisible: !!it.value
                                    }
                                ]}
                            />
                        )
                    }
                }, {
                    isClearable: true,
                    api: 'api/' + Resources.ContactGroupsQuick,
                    query: {},
                    searchMap: (it) => ({
                        label: it.ContactGroupName,
                        value: it.ContactGroupID,
                        metadata: it
                    })
                }
            ),

            OfficeID: new Field('OfficeID', getDefaultUserOfficeValues(), ['empty'], false, 'select-search',
                {
                    addContainerClass: "col-span-full xl:col-span-6",
                }, {
                    api: 'api/' + Resources.OfficesQuick,
                    query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                    searchMap: (item) => ({
                        label: item.OfficeName,
                        value: item.OfficeID
                    })
                }
            ),

            UserDefinedField1: new Field('UserDefinedField1', '', [], false, "test", {addContainerClass: "col-span-full"}),
            UserDefinedField2: new Field('UserDefinedField2', '', [], false, "test", {addContainerClass: "col-span-full"}),

            // Card 2
            AreaCode: new Field('AreaCode', '', [], false, 'select', {
                addContainerClass: "col-span-2"
            }),
            PhoneNumber: new Field('PhoneNumber', '', [''], false, 'mask', {}, {
                showMask: true,
                mask: FIELD_MASK_PHONE
            }),
            PhoneExtension: new Field('PhoneExtension', '', []),
            PrimaryEmail: new Field('PrimaryEmail', '', ['']),
            SCAC: new Field('SCAC', '', [''], false, 'text', {}, {
                max: SCAC_CODE_FIELD_LENGTH,
                upperCaseOnly: true
            }),
            OrganizationEntityTypeID: new Field('OrganizationEntityTypeID', '', [''], false, 'select', {
                addContainerClass: "col-span-2"
            }),
            MCNumber: new Field('MCNumber', '', [''], false, 'text', {}, {
                max: 10,
            }),
            USDOTNumber: new Field('USDOTNumber', '', [''], false, 'text', {}, {
                max: 10,
            }),
            FederalID: new Field('FederalID', '', [''], false, 'mask', {}, {
                showMask: true,
                mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                onFocus: (event) => {
                    setSelectionRange('FederalID', event.target.value)
                }
            }),
            NaicsID: new Field('NaicsID', '', [''], false, 'select'),
            SendPromotionalEmails: new Field('SendPromotionalEmails', 1, [], false, 'checkbox'),

            // Card 3
            Notes: new Field('Notes', '', [], false, 'textarea'),

            // Card 4
            ContractOnFile: new Field('ContractOnFile', '', [], false, 'checkbox'),
            ContractStartDate: new Field('ContractStartDate', '', [''], true, 'date', {label: "CompanyContractStartDate"}, {}),
            ContractEndDate: new Field('ContractEndDate', '', [''], true, 'date', {}, {}),
            ContactNumber: new Field('ContactNumber', '', [''], true),
        }
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props

        const isLoading = resource.isLoading;

        return (
            <Layout
                {...this.props}
                hasFooter={true}
                isDirty={this.state.canSubmit}
            >
                <Page>
                    <div className="flex justify-between items-center">
                        <div className="mb-2 flex justify-start items-center">
                            <GoBackButton
                                translate={this.props.translate}
                                history={this.props.history}
                                path={'/customers'}
                            />
                            <h1
                                className={'mr-5 text-3xl ml-2'}> {translate('text.create')} {translate('page.heading.customer')}</h1>
                        </div>

                        <div>

                        </div>
                    </div>

                    <div className="mb-5 hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                     <div className="mb-5">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="relative pb-20">
                        {isLoading && (
                            <LoaderLarge stripesBg={true}/>
                        )}

                        {this.state.selectedTab === Resources.CustomersInfo && (
                            <InfoTab
                                setLocations={this.handleSetLocations}
                                handleItemInputChange={this.handleItemInputChange}
                                handleInputChange={this.handleInputChange}
                                fields_info={this.state.fields_info}
                                {...this.props}/>
                        )}

                        {this.state.selectedTab === Resources.CustomersDocuments && (
                            <Card>
                                <DocumentsCreateTab
                                    fields={this.state.fields_documents}
                                    translate={this.props.translate}

                                    dialogTitle={'Driver Documents'}

                                    documentTypes={getDocumentTypesFor("IsCompanyDocument")}
                                    handleUploadDocument={this.handleUploadDocument}
                                    handleDeleteDocument={this.handleDeleteDocument}
                                />
                            </Card>
                        )}

                        {this.state.selectedTab === Resources.CustomersReviews && (
                            <ReviewsTab
                                addNewReview={this.handleAddNewReview}
                                removeNewReview={this.handleRemoveReview}
                                fields_reviews={this.state.fields_reviews}
                                {...this.props}/>
                        )}
                    </div>

                    <PageFooter
                        translate={translate}
                        canSubmit={this.state.canSubmit}
                        actionCancel={this.handleFormCancel}
                        actionSubmit={checkPerm(Resources.Customers, CREATE_PERM) && this.onSubmit}
                    />
                </Page>

                <RedirectDialog
                    show={this.state.redirectModalOpen}
                    title={translate('card_header.customer_created')}
                    onClose={() => {
                        this.props.dispatch(resetResource())
                        this.setState({
                            createdResourceID: null,
                            redirectModalOpen: false
                        })
                    }}

                    createdLabel={translate('btn.customer')}
                    createdLink={`/customers/info/${this.state.createdOrganizationID}/${this.state.createdResourceID}`}

                    newLabel={translate('btn.create_new')}

                    listLabel={translate('btn.list')}
                    listLink="/customers"

                    dashboardLabel={translate('btn.dashboard')}

                    {...this.props}
                >
                    <p>{translate('message.customer_created')}</p>
                </RedirectDialog>

                <GroupsViewDialog
                    groupID={this.state.fields_info?.ContactGroupID?.value?.value}
                    isGroupInfoDialogOpen={this.state.isGroupInfoDialogOpen}
                    groupInfoData={this.state.groupInfoData}
                    onClose={() => this.setState({
                        isGroupInfoDialogOpen: false
                    })}
                    translate={translate}
                />
            </Layout>
        )
    }
}

export default connect(state => state)(CustomerCreateNew)

